import uzDictionary from './uz'

export default uzDictionary
